import FAQProvider from "../provider/FAQProvider"
import FAQResults from "./Results"
import FAQSearchBox from "./SearchBox"

export type FAQsModel = {
  source: number,
  resultMessage: string,
  noResultMessage: string
}

export default function FAQs({ source, resultMessage, noResultMessage }: FAQsModel) {
  return (
    <FAQProvider source={source}>
      <FAQSearchBox />
      <FAQResults resultMessage={resultMessage} noResultMessage={noResultMessage} />
    </FAQProvider>
  )  
}